<template>
  <!-- レーダ画像表示 -->
  <div>
    <div v-for="(value, index) in setOverlayA" v-bind:key="'radarA-' + index">
      <l-image-overlay
        :url="value.img.src"
        :bounds="value.bounds"
        :opacity="opacity"
        :visible="showRadar == 'A'"
        className="com-map-radar-image"
      />
    </div>
    <div v-for="(value, index) in setOverlayB" v-bind:key="'radarB-' + index">
      <l-image-overlay
        :url="value.img.src"
        :bounds="value.bounds"
        :opacity="opacity"
        :visible="showRadar == 'B'"
        className="com-map-radar-image"
      />
    </div>
  </div>
</template>
<!-- ----------------------------------------------- -->
<script>
import { LImageOverlay } from "vue2-leaflet";
import Util from "../../../lib/util.js";
import MapUtil from "../../../lib/mapUtil.js";

/**
 * 川の防災情報 地図画面 レーダ画像レイヤー
 * RiverWarnLayer.vue
 * @author LIS
 */
export default {
  name: "radar-layer",
  components: {
    LImageOverlay,
  },
  /** データ部 */
  data() {
    return {
      // 日時毎の表示イメージリスト
      showImageList: [],
      // 選択中日時のイメージ
      setOverlay: [],
      // イメージ更新時のチラつき抑止のため表示データを2面で管理
      setOverlayA: [],
      setOverlayB: [],
      // 動画再生準備完了の判断に使用する、全読み込み画像数
      allImgNum: 0,
      // 動画再生準備完了の判断に使用する、読み込み完了(or 失敗)画像数
      onloadImgNum: 0,
      // 表示レイヤー
      showRadar: "A",
      // 地図移動後レーダ画像取得要求待機用タイマーID
      requestWaitTimerId: null,
    };
  },
  /** プロパティ部 */
  props: {
    mapNum: {
      type: Number,
      default: 0,
    },
  },
  /** 初期化部 */
  mounted() {
    // レーダ画像取得要求
    this.requestRadarImage();
    // レーダ画像設定
    this.setImageList();
  },
  /** 算出部 */
  computed: {
    /** 地図設定情報 */
    mapConfig: {
      get() {
        return this.$store.state.map.mapConfig;
      },
    },
    /** 透過設定 */
    opacity: {
      get() {
        // 不透明度に反転して、パーセント指定を少数に変換して返す
        return (100 - this.$store.state.radar.radarOpacity) * 0.01;
      },
    },
    /** レーダ雨量の種類の取得 */
    radarType: {
      get() {
        return this.$store.state.radar.radarType;
      },
    },
    /** 地図の表示時間間隔 */
    radarInterval: {
      get() {
        return this.$store.state.radar.radarInterval;
      },
    },
    /** 基準時間を計算 */
    baseTime: {
      get() {
        let radarTime = this.$store.state.app.appTime;
        if (this.$store.state.app.isCurrent) {
          if (this.$store.state.radar.radarType == "xrain") {
            radarTime = this.$store.state.radar.radarXrainDate;
          } else {
            radarTime = this.$store.state.radar.radarCbandDate;
          }
          // 初期表示直後のレーダ観測日時取得前状態を考慮
          if (!radarTime) {
            return null;
          }
        }

        let returnTime = MapUtil.calcBaseTime(
          radarTime,
          this.mapNum,
          this.$store.state.radar.radarInterval
        );
        // 1枚目以外(過去日時)は、5分間隔に切り捨て
        if (this.mapNum != 0) {
          returnTime.setMinutes(Math.floor(returnTime.getMinutes() / 5) * 5);
        }
        return returnTime;
      },
    },
    /** レーダ画像情報 */
    radarImage: {
      get() {
        return this.$store.state.radar.radarImage;
      },
    },
    /** レーダ画像パラメータ */
    radarParam: {
      get() {
        return this.$store.state.radar.radarImageParam;
      },
    },
    /** 履歴動画再生状態 */
    historyPlayStatus: {
      get() {
        return this.$store.state.radar.historyPlayStatus;
      },
    },
    /** 地図左下・右上座標の取得 */
    minmaxCoord: {
      get() {
        return [this.$store.state.map.minCoord, this.$store.state.map.maxCoord];
      },
    },
  },
  /** メソッド */
  methods: {
    /** レーダ画像設定 */
    setImageList() {
      this.showImageList = [];
      this.setOverlay = [];
      let url = "";
      let typeUrl = "";
      let levelUrl = "";
      let areaUrl = "";
      let dateUrl = "";
      let timeUrl = "";
      let fileName = "";
      // radarストアのレーダ画像情報
      const radarImageList = this.radarImage;

      // 動画再生準備完了の判断のため、読み込み対象の全画像数を設定
      let allImgCnt = 0;
      for (let imgCnt = 0; imgCnt < radarImageList.length; imgCnt++) {
        if (
          null != radarImageList[imgCnt].reqDate &&
          null != radarImageList[imgCnt].areaInfo
        ) {
          if (
            this.$store.state.radar.radarNumber == 1 ||
            (this.$store.state.radar.radarNumber == 4 &&
              radarImageList[imgCnt].reqDate.getTime() ==
                this.baseTime.getTime())
          ) {
            for (let i = 0; i < radarImageList[imgCnt].areaInfo.length; i++) {
              allImgCnt++;
            }
          }
        }
      }
      this.allImgNum = allImgCnt;
      this.onloadImgNum = 0;
      // 読み込み対象が存在しない場合、動画再生ステータスを即座に更新する
      if (this.allImgNum == 0 && this.$store.getters["radar/isReadyMap"]) {
        this.$store.commit("map/setHistoryPlayPrepStatus", "playable");
      }

      // radarストアに保持している日時毎のレーダ画像情報の数だけ処理を行う
      for (let imgCnt = 0; imgCnt < radarImageList.length; imgCnt++) {
        let showImage = [];
        const radarImage = radarImageList[imgCnt];
        if (null != radarImage.reqDate && null != radarImage.areaInfo) {
          // 4枚表示の場合は、不要な画像読み込みを行わないように自身の対象日時のデータのみ処理する
          if (
            this.$store.state.radar.radarNumber == 1 ||
            (this.$store.state.radar.radarNumber == 4 &&
              radarImage.reqDate.getTime() == this.baseTime.getTime())
          ) {
            // レーダ種別設定
            if (radarImage.type === "xrain") {
              typeUrl = this.mapConfig.url.radar.xrain;
            } else if (radarImage.type === "cband") {
              typeUrl = this.mapConfig.url.radar.cband;
            }

            // 画像階層レベル設定
            if (radarImage.level === 1) {
              levelUrl = this.mapConfig.url.radar.wide;
            } else if (radarImage.level === 2) {
              levelUrl = this.mapConfig.url.radar.area;
            } else if (radarImage.level === 3) {
              levelUrl = this.mapConfig.url.radar.pref;
            }

            // 日付設定
            dateUrl = Util.formatDate(radarImage.obsDate, "YYYYMMDD") + "/";
            // 時分設定
            timeUrl = Util.formatDate(radarImage.obsDate, "HHmm") + "/";

            for (let i = 0; i < radarImage.areaInfo.length; i++) {
              // エリアコード設定
              areaUrl = radarImage.areaInfo[i].areaCd + "/";
              // ファイル名設定
              fileName = radarImage.areaInfo[i].seq + ".png";

              url =
                this.mapConfig.url.radar.root +
                typeUrl +
                areaUrl +
                levelUrl +
                dateUrl +
                timeUrl +
                fileName;

              // 動画再生準備中に全画像の取得を行っておくため、Imageオブジェクトを生成する
              let img = new Image();
              // 画像読み込みが完了(or 失敗)した場合に、読み込み画像数を更新する
              img.onload = () => {
                this.onloadImgNum++;
              };
              img.onerror = () => {
                this.onloadImgNum++;
              };
              img.src = url;
              // 既に画像読み込み済みの画像の場合に、読み込み画像数を更新する
              if (img.complete) {
                this.onloadImgNum++;
              }

              showImage.push({
                img: img,
                bounds: [
                  [
                    radarImage.areaInfo[i].latMin,
                    radarImage.areaInfo[i].lngMin,
                  ],
                  [
                    radarImage.areaInfo[i].latMax,
                    radarImage.areaInfo[i].lngMax,
                  ],
                ],
              });
            }
            this.showImageList.push({
              date: radarImage.reqDate,
              image: showImage,
            });
          }
        }
      }
      this.selectShowImageList();
    },
    /** 表示対象を選択 */
    selectShowImageList() {
      for (let sCnt = 0; sCnt < this.showImageList.length; sCnt++) {
        if (
          this.showImageList[sCnt].date.getTime() == this.baseTime.getTime()
        ) {
          this.setOverlay = this.showImageList[sCnt].image;
        }
      }
    },
    /** レーダ画像取得要求 */
    requestRadarImage() {
      // 初期表示のレーダ観測日時取得前状態の場合は要求しない
      if (this.baseTime) {
        // 履歴動画再生状態が「履歴動画再生/準備中以外状態」の場合のみ行う
        if (this.$store.getters["radar/isNotPlay"]) {
          // 地図番号が0(1枚表示か4枚表示の1枚目)のときのみ処理を行う
          if (this.mapNum == 0) {
            this.$store.dispatch("radar/requestRadarImage", {
              zoom: this.$store.state.map.zoom,
              time: this.baseTime,
              current: this.$store.state.app.isCurrent,
              minCoord: this.$store.state.map.minCoord,
              maxCoord: this.$store.state.map.maxCoord,
            });
          }
        }
      }
    },
  },
  /** 監視部 */
  watch: {
    /** レーダ雨量の種類を監視 */
    radarType() {
      this.requestRadarImage();
    },
    /** 基準時間を監視 */
    baseTime(afterTime, beforeTime) {
      // 日付が変更されている場合のみ処理する
      if (Util.formatDate(afterTime) != Util.formatDate(beforeTime)) {
        this.selectShowImageList();
        // 動画停止中の観測日時更新ではレーダ画像取得要求を行わない
        if (!this.$store.getters["radar/isStop"]) {
          this.requestRadarImage();
        }
      }
    },
    /** 地図の表示時間間隔 */
    radarInterval() {
      this.requestRadarImage();
    },
    /** レーダ画像を監視 */
    radarParam() {
      if (
        this.radarParam &&
        (this.$store.getters["radar/isNotPlay"] ||
          this.$store.getters["radar/isReadyMap"])
      ) {
        // 履歴動画再生状態が「地図準備状態」または「停止状態」の場合のみレーダ画像設定を行う
        this.$store.commit("map/setHistoryPlayPrepStatus", "ready");
        this.setImageList();
      }
    },
    /** 履歴動画再生状態 */
    historyPlayStatus() {
      // 履歴動画再生状態リセット直後にレーダ画像の再取得を行う
      if (this.$store.getters["radar/isNone"]) {
        this.requestRadarImage();
      }
    },
    /** 読み込み完了(or 失敗)画像数 */
    onloadImgNum() {
      if (this.onloadImgNum == this.allImgNum) {
        // 地図準備状態の場合に、leafletの更新処理が完了したタイミングでステータスを更新する
        if (this.$store.getters["radar/isReadyMap"]) {
          this.$store.commit("map/setHistoryPlayPrepStatus", "playable");
        }
      }
    },
    /** 地図左下・右上座標の取得 */
    minmaxCoord() {
      if (this.$store.getters["radar/isStop"]) {
        // 動画再生時は地図移動契機でステータスリセットを行う
        this.$store.commit("radar/resetHistoryPlay");
      }
      // 地図移動が連続して行われた際に途中の状態での取得を行わないように
      // レーダ画像取得要求は地図移動後一定時間停止している場合のみ行う
      let waitTime = this.$store.state.radar.radarConfig.updateWaitTimeXrain;
      if (this.$store.state.radar.radarType == "cband") {
        waitTime = this.$store.state.radar.radarConfig.updateWaitTimeCband;
      }
      clearTimeout(this.requestWaitTimerId);
      this.requestWaitTimerId = setTimeout(
        function() {
          this.requestRadarImage();
        }.bind(this),
        waitTime
      );
    },
    /** 選択中日時のイメージ */
    setOverlay() {
      if (this.showRadar == "A") {
        // Bに表示イメージをセット
        this.setOverlayB = this.setOverlay;
        // 一定時間後にBに切替
        setTimeout(
          function() {
            this.showRadar = "B";
          }.bind(this),
          this.$store.state.radar.radarConfig.displayWaitTime
        );
      } else {
        // Aに表示イメージをセット
        this.setOverlayA = this.setOverlay;
        // 一定時間後にAに切替
        setTimeout(
          function() {
            this.showRadar = "A";
          }.bind(this),
          this.$store.state.radar.radarConfig.displayWaitTime
        );
      }
    },
  },
};
</script>
<!-- ----------------------------------------------- -->
<style lang="scss" scoped>
@import "../../../scss/kwb.scss";
</style>
